import React, { Children } from "react";
import { ManageTradeLayout } from "../../components";
import { Button, Image } from "react-bootstrap";
import { manageTradeFormNames, formFields } from "../../utils";
import { SearchView } from "./SearchView";
import ExcelImage from "../../styles/exportimg.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { isEmpty } from "lodash";

export const CardsLayout = (props) => {
  const onSubmit = () => {};
  return (
    <ManageTradeLayout>
      <div className="transaction-view-trade">
        <SearchView onSubmit={onSubmit} />
        <div className="d-flex recently-added-with-export">
          <div className="recently-added-text">
            <div className="main-text">Recently Added/Modified</div>
            <div className="sub-text">20 Records found</div>
          </div>
          <div>
            <span
              className="mr-2 mt-12 sort-button cursor-pointer payroll-btns"
              style={{ lineHeight: "19px" }}
              // onClick={() => exportReportFile()}
            >
              <Image src={ExcelImage} width="20px" />
              <u>Export</u>
            </span>
          </div>
        </div>

        {props.children}
      </div>
      {/* <div className="d-flex justify-content-space-between">
                <div style={{ marginTop: "10px", width: "870px" }}>
                    <div>
                        <p className="files-list-text">Recently Added/Modified</p>
                    </div>
                    <div className="grey-text" style={{ marginTop: "5px" }}>
                        <p
                            className="grey-text"
                            style={{
                                fontSize: "12px",
                                marginBottom: "0px",
                            }}
                        >
                            20 Records found
                        </p>
                    </div>
                </div>
                <div>
                    <span
                        className="mr-2 mt-12 sort-button cursor-pointer payroll-btns"
                        style={{ lineHeight: "19px" }}
                        // onClick={() => exportReportFile()}
                    >
                        <Image src={ExcelImage} width="20px" />
                        <u>Export</u>
                    </span>
                   
                </div>
            </div> */}
      {/* <>
          
            
            </> */}
    </ManageTradeLayout>
  );
};
